<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-content">
        <p class="company-info">{{ $t('footer.company') }}</p>
        <p class="description">{{ $t('footer.description') }}</p>
        <p class="copyright">{{ $t('footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.site-footer {
  background-color: #2c3e50;
  color: #ffffff;
  padding: 2rem 0;
  margin-top: 4rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-content {
  text-align: center;
}

.company-info {
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 500;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.description {
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 300;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  opacity: 0.9;
}

.copyright {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 0.85rem;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .company-info {
    font-size: 1rem;
  }
  
  .description {
    font-size: 0.85rem;
  }
  
  .copyright {
    font-size: 0.8rem;
  }
}
</style>
